












































import Vue from "vue";
import StatusLine from "./StatusLine.vue";

const stepOption = [
  { label: "10分钟", value: "10m" },
  { label: "30分钟", value: "30m" },
  { label: "1小时", value: "1h" },
  { label: "1天", value: "24h" }
];

function groupBy(data: any) {
  switch (data.result) {
    case "error":
      return "错误";
    case "scheduled":
      return "成功";
    case "unschedulable":
      return "失败";
  }
}

const monitor = [
  {
    title: "在线实例数",
    type: "scheduler_up_sum"
  },
  {
    title: "调度次数",
    type: "scheduler_schedule_attempts",
    legend: true,
    groupBy
  },
  {
    title: "调度延迟(s)",
    type: "scheduler_e2e_scheduling_latency"
  },
  {
    title: "调度速率(次/s)",
    type: "scheduler_schedule_attempt_rate",
    legend: true,
    groupBy
  }
];

export default Vue.extend({
  name: "Physical",
  components: { StatusLine },
  data() {
    return {
      date: [] as Array<Date>,
      step: "10m",
      stepOption,
      monitor
    };
  },
  mounted() {
    this.init();
    this.getData();
  },
  methods: {
    init() {
      const start = new Date();
      const end = new Date();

      start.setTime(start.getTime() - 3600 * 1000 * 2);
      // 默认选中 近两小时
      this.date = [start, end];
    },
    getData() {
      this.$nextTick(() => {
        (this.$refs.line as Vue[]).forEach(line => {
          (line as any).getData();
        });
      });
    },
    getDefaultData() {
      const now = new Date().getTime();
      switch (this.step) {
        case "10m":
          this.$set(this, "date", [
            new Date(now - 12 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "30m":
          this.$set(this, "date", [
            new Date(now - 24 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "1h":
          this.$set(this, "date", [
            new Date(now - 48 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "24h":
          this.$set(this, "date", [
            new Date(now - 24 * 7 * 3600 * 1000),
            new Date(now)
          ]);
          break;
      }
      this.getData();
    }
  }
});
